import { render, staticRenderFns } from "./PatientChartInfoCrm.vue?vue&type=template&id=a47c4322&scoped=true&"
import script from "./PatientChartInfoCrm.vue?vue&type=script&lang=js&"
export * from "./PatientChartInfoCrm.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/page/patientChartInfoCrm.css?vue&type=style&index=0&id=a47c4322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47c4322",
  null
  
)

export default component.exports